/**Dependencies */
import { Col, Image, Row } from "react-bootstrap";
import imgPreview from "../images/preview.jpg";
import { settingsInfoHotel } from "../utils";
import Slider from "react-slick";

export const GalleryInfo = ({ images, urlImg, isHotel }) => {
  return (
    <>
      {isHotel ? (
        <Col lg={9} md={8} sm={12} className="mb-5 mb-md-0 mb-lg-0">
          <Row className="d-flex">
            <Col xs={12} md={8}>
              <a
                href={urlImg + images[0].url}
                data-lightbox="gallery"
                data-title={"image1"}
              >
                <Image
                  src={urlImg + images[0].url}
                  alt={"image1"}
                  fluid
                  className="border-first-image"
                  style={{
                    cursor: "pointer",
                    height: "597px",
                    width: "100%",
                    objectFit: "cover",
                  }}
                  onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                />
              </a>
            </Col>

            {/* Columna derecha: Imágenes pequeñas */}
            <Col xs={12} md={4} className="mt-2 mt-md-0 mt-lg-0">
              <Row>
                <Col md={12} xs={4} lg={12}>
                  <a
                    href={urlImg + images[1].url}
                    data-lightbox="gallery"
                    data-title={"image2"}
                  >
                    <Image
                      src={urlImg + images[1].url}
                      alt={"image2"}
                      fluid
                      className="border-second-image"
                      style={{
                        cursor: "pointer",
                        height: "204px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                    />
                  </a>
                </Col>
                <Col md={12} xs={4} className="my-lg-2 my-0 my-md-2" lg={12}>
                  <a
                    href={urlImg + images[2].url}
                    data-lightbox="gallery"
                    data-title={"image2"}
                  >
                    <Image
                      src={urlImg + images[2].url}
                      className="border-third-image"
                      alt={"image3"}
                      fluid
                      style={{ cursor: "pointer", width: "100%", objectFit: "cover", }}
                      onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                    />
                  </a>
                </Col>
                <Col md={12} xs={4} lg={12}>
                  <div
                    className="border-last-image"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      cursor: "pointer",
                    }}
                  >
                    <a
                      href={urlImg + images[3].url}
                      data-lightbox="gallery"
                      data-title={"image4"}
                    >
                      <Image
                        src={urlImg + images[3].url}
                        alt={"image4"}
                        fluid
                        style={{
                          filter: "blur(5px)",
                          pointerEvents: "none",
                          height: "204px",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          color: "white",
                          fontSize: "1.5rem",
                          borderBottomRightRadius: "15px",
                          textAlign: "center",
                        }}
                      >
                        + {images.length} Fotos
                      </div>
                    </a>
                  </div>
                </Col>
              </Row>
              {/* <Row className="mb-2">
          
          </Row>
          <Row>
         
          </Row> */}
            </Col>
          </Row>
          <Row className="d-none pb-3">
            {images?.slice(5).map((img, index) => (
              <a
                key={index + 1}
                href={img.url ? urlImg + img.url : imgPreview}
                data-lightbox="gallery"
                data-title={"slide6"}
                style={{ textDecoration: "none" }}
              >
                <div>
                  <img
                    src={img.url ? urlImg + img.url : imgPreview}
                    alt={"slide6"}
                    className="img-grid-sm"
                    style={{ filter: "blur(3px)", objectFit: "cover", }}
                    onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                  />
                </div>
              </a>
            ))}
          </Row>
        </Col>
      ) : (
        <>
          <Col
            lg={12}
            md={12}
            sm={12}
            className="mb-5 mb-md-0 mb-lg-0 d-md-flex d-none"
          >
            <Row className="d-flex">
              <Col xs={12} md={8}>
                <a
                  href={images?.[0]?.urls[1]?.resource}
                  data-lightbox="gallery"
                  data-title={"image1"}
                >
                  <Image
                    src={images?.[0]?.urls[1]?.resource}
                    alt={"image1"}
                    fluid
                    className="border-first-image"
                    style={{
                      cursor: "pointer",
                      height: "597px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                  />
                </a>
              </Col>

              {/* Columna derecha: Imágenes pequeñas */}
              <Col xs={12} md={4} className="mt-2 mt-md-0 mt-lg-0">
                <Row>
                  <Col md={12} xs={4} lg={12}>
                    <a
                      href={images?.[1]?.urls[1]?.resource}
                      data-lightbox="gallery"
                      data-title={"image2"}
                    >
                      <Image
                        src={images?.[1]?.urls[1]?.resource}
                        alt={"image2"}
                        fluid
                        className="border-second-image"
                        style={{
                          cursor: "pointer",
                          height: "204px",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                      />
                    </a>
                  </Col>
                  <Col md={12} xs={4} className="my-lg-2 my-0 my-md-2" lg={12}>
                    <a
                      href={images?.[2]?.urls[1]?.resource}
                      data-lightbox="gallery"
                      data-title={"image2"}
                    >
                      <Image
                        src={images?.[2]?.urls[1]?.resource}
                        className="border-third-image"
                        alt={"image3"}
                        fluid
                        style={{ cursor: "pointer", width: "100%", objectFit: "cover", }}
                        onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                      />
                    </a>
                  </Col>
                  <Col md={12} xs={4} lg={12}>
                    <div
                      className="border-last-image"
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                    >
                      <a
                        href={images?.[3]?.urls[1]?.resource}
                        data-lightbox="gallery"
                        data-title={"image4"}
                      >
                        <Image
                          src={images?.[3]?.urls[1]?.resource}
                          alt={"image4"}
                          fluid
                          style={{
                            filter: "blur(5px)",
                            pointerEvents: "none",
                            height: "204px",
                            width: "100%",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                        />
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            color: "white",
                            fontSize: "1.5rem",
                            borderBottomRightRadius: "15px",
                            textAlign: "center",
                          }}
                        >
                          + {images?.length} Fotos
                        </div>
                      </a>
                    </div>
                  </Col>
                </Row>
                {/* <Row className="mb-2">
          
          </Row>
          <Row>
         
          </Row> */}
              </Col>
            </Row>
            <Row className="d-none pb-3">
              {images?.slice(5)?.map((img, index) => (
                <a
                  key={index + 1}
                  href={img ? img?.urls[1]?.resource : imgPreview}
                  data-lightbox="gallery"
                  data-title={"slide6"}
                  style={{ textDecoration: "none" }}
                >
                  <div>
                    <img
                      src={img ? img?.urls[1]?.resource : imgPreview}
                      alt={"slide6"}
                      className="img-grid-sm"
                      style={{ filter: "blur(3px)", objectFit: "cover", }}
                      onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                    />
                  </div>
                </a>
              ))}
            </Row>
          </Col>
          <Col lg={12} md={12} xs={12} className="d-flex d-md-none">
            <Slider className="w-100" {...settingsInfoHotel}>
              {images?.map((img, index) => {
                return (
                  <Col
                    lg={12}
                    md={4}
                    sm={12}
                    key={index + 1}
                    className="d-flex justify-content-center pt-4"
                  >
                    <img
                      src={img?.urls[1]?.resource}
                      alt={"Experiencia"}
                      style={{ width: "100%", height: "100%", objectFit: "cover", }}
                      onError={(e) => {
                    e.currentTarget.src = imgPreview;
                    e.currentTarget.alt = "Imagen de hotel";
                  }}
                    />
                  </Col>
                );
              })}
            </Slider>
          </Col>
        </>
      )}
    </>
  );
};
